export default __webpack_public_path__ + "static/Logo-inverted-83f597ea5f10299df9a8e6b0e409cf0e.svg";